"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ECheckEmailStatus = exports.ECheckEmailError = void 0;
let ECheckEmailStatus = exports.ECheckEmailStatus = /*#__PURE__*/function (ECheckEmailStatus) {
  ECheckEmailStatus["Initial"] = "initial";
  ECheckEmailStatus["Loading"] = "loading";
  ECheckEmailStatus["Succeed"] = "succeed";
  ECheckEmailStatus["Failed"] = "failed";
  return ECheckEmailStatus;
}({});
let ECheckEmailError = exports.ECheckEmailError = /*#__PURE__*/function (ECheckEmailError) {
  ECheckEmailError["Common"] = "common";
  ECheckEmailError["LimitReached"] = "limitReached";
  ECheckEmailError["Unexpected"] = "unexpected";
  return ECheckEmailError;
}({});